import axiosInstance from "./api/axiosInstance";

const requestWithdrawal = async (withdrawalData) => {
  const response = await axiosInstance.post("withdraw", withdrawalData);
  return response.data;
};

const cancelWithdrawal = async (withdrawalId, clientId) => {
  const config = {
    headers: { "X-Client-ID": clientId },
  };
  const response = await axiosInstance.patch(
    `withdraw/cancel/${withdrawalId}`,
    {}, // Corpo vazio
    config
  );
  return response.data;
};

export const withdrawService = {
  requestWithdrawal,
  cancelWithdrawal,
};
